import deepCopy from 'deepcopy';
import { getOrderTypesRequest, updateOrderTypesRequest } from '../requests';
import { throttle } from '@/core';
import rdbClient from 'rdb-client';

async function getOrderTypes({ state, commit }) {
	try {
		if (state.orderTypes.length === 0) {
			await fetchOrderTypes();
		} else {
			await throttle(fetchOrderTypes, 'fetchOrderTypes', 60 * 1000);
		}
	} catch (err) {
		console.log(`Get orderTypes failed: ${err}`);
	}

	async function fetchOrderTypes() {
		let response = await getOrderTypesRequest();
		commit('setOrderTypes', response);
	}
}

async function setOrderTypesIcon(context, { orderType, iconId }) {
	try {
		let orderTypeClone = deepCopy(orderType);
		orderType.iconId = iconId;
		let patch = rdbClient.createPatch(orderTypeClone, orderType);
		await updateOrderTypesRequest(orderType.id, { patch });
	} catch (err) {
		console.log(`Failed to update order type: ${err}`);
	}
}

export default {
	getOrderTypes,
	setOrderTypesIcon
};